/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import * as api from "../../api";
import * as account from "./account";
import * as partner_pay from "./partner_pay";
import * as form_page from "../../operation/data/form_page";
import * as partner_sample from "./partner_sample";
import * as partner_creator from "./partner_creator";
import * as partner_product from "./partner_product";
export { api, account, partner_pay, form_page, partner_sample, partner_creator, partner_product };
export var PartnerType = {
  PartnerType_UNSPECIFIED: 0,
  MCN: 1,
  TSP: 2,
  TalentScout: 3,
  AffiliatePartner: 4
};
export var PartnerStatus = {
  PartnerStatus_UNSPECIFIED: 0,
  NEW_CREATE: 1,
  PENDING_REVIEW: 2,
  ACTIVE: 3,
  FREEZE: 4,
  DEACTIVE: 5
};
export var PartnerAccountStatus = {
  INIT: 0,
  TO_ACTIVATE: 1,
  ACTIVATING: 2,
  ACTIVATED: 3,
  ACTIVATE_FAIL: 4
};
export var PartnerPaymentsStatus = {
  UNLINKED: 0,
  LINKED: 1
};
export var SettlementStatus = {
  BIND_SUCCEED: 0,
  INVALID: 1,
  VALIDATING: 2
};
export var PartnerEarningDetailType = {
  PENDING_PAYMENT: 0,
  PAID: 1,
  FAILED: 2
};
export var PartnerEarningExportType = {
  SELECTED: 0,
  ALL: 1
};
export var PartnerEmployeeType = {
  PartnerEmployeeType_UNSPECIFIED: 0,
  MAIN_ACCOUNT: 1,
  EMPLOYEE: 2
};
export var PartnerMetricType = {
  AGENCY_PROFILE_TAP_CAMPAIGN_GMV_30D: 1,
  AGENCY_PROFILE_TAP_CAMPAIGN_SV_POSTED_30D: 2,
  AGENCY_PROFILE_TAP_CAMPAIGN_SV_CREATORS_30D: 3,
  AGENCY_PROFILE_NUM_LINKED_CREATORS: 4,
  AGENCY_PROFILE_LINKED_CREATORS_MONETIZING: 5,
  AGENCY_PROFILE_CAP_BOUND_CREATOR_GMV_30D: 6,
  AGENCY_PROFILE_LIVE_BOUND_CREATOR_GMV_30D: 7,
  AGENCY_PROFILE_LIVE_HIGHEST_SINGLE_LIVEROOM_GMV_180D: 8,
  AGENCY_PROFILE_TOP_PRODUCTS_BY_AVG_COMMISSION_7D: 9,
  AGENCY_PROFILE_TOP_CATEGORIES_BY_GMV_30D: 10
};
export var RelationStatus = {
  RELATION_STATUS_UNSPECIFIED: 0,
  BOUND: 1,
  PENDING: 2,
  UNBOUND: 3,
  UNBINDING: 4,
  BINDING_FAILED: 5,
  BINDING_FAILED_REJECT: 6,
  BINDING_FAILED_EXPIRED: 7,
  UNBINDING_FROM_PARTNER: 8,
  UNBOUND_UNBINDING_APPROVED: 9,
  UNBOUND_BINDING_EXPIRED: 10,
  UNBOUND_PARTIALLY_BIND: 11,
  BINDING_EXPIRE_SOON: 12
};
export var RelationAction = {
  RELATION_ACTION_UNSPECIFIED: 0,
  UNLINK: 1,
  APPROVE: 2,
  REJECT: 3,
  EXTEND: 4
};
export var CommissionAuthExpireTimeFilter = {
  COMMISSION_AUTH_EXPIRE_TIME_FILTER_UNSPECIFIED: 0,
  COMMISSION_AUTH_EXPIRE_TIME_FILTER_ALL: 1,
  COMMISSION_AUTH_EXPIRE_TIME_FILTER_LESS_THAN_3_DAYS_LEFT: 2
};
export var CommissionAuthRequestFromType = {
  COMMISSION_AUTH_REQUEST_FROM_UNSPECIFIED: 0,
  COMMISSION_AUTH_REQUEST_FROM_PARTNER: 1,
  COMMISSION_AUTH_REQUEST_FROM_CREATOR: 2
};
export var RequestFromType = {
  REQUEST_FROM_UNSPECIFIED: 0,
  REQUEST_FROM_PARTNER: 1,
  REQUEST_FROM_CREATOR: 2
};
export var RelationRecordType = {
  RELATION_RECORD_UNSPECIFIED: 0,
  RELATION_RECORD_INVITE: 1,
  RELATION_RECORD_INVITE_REJECT: 2,
  RELATION_RECORD_INVITE_APPROVE: 3,
  RELATION_RECORD_INVITE_EXPIRE: 4,
  RELATION_RECORD_BIND_EXPIRE: 5,
  RELATION_RECORD_PARTNER_UNBIND: 6,
  RELATION_RECORD_CREATOR_UNBIND: 7,
  RELATION_RECORD_CREATOR_REJECT_UNBIND: 8,
  RELATION_RECORD_PARTNER_REJECT_UNBIND: 9,
  RELATION_RECORD_PARTNER_UNBIND_EXPIRE: 10,
  RELATION_RECORD_CREATOR_UNBIND_EXPIRE: 11,
  RELATION_RECORD_CREATOR_APPROVE_UNBIND: 12,
  RELATION_RECORD_PARTNER_APPROVE_UNBIND: 13
};
export var ReasonCode = {
  REASON_CODE_UNSPECIFIED: 0,
  AGENCY_NEVER_RESPONDS: 1,
  AGENCY_KEEPS_REJECTING: 2,
  NO_HELP_FROM_AGENCY: 3,
  FAKE_SPAM_AGENCY: 4,
  NOT_KNOW_LINKED_WITH_AGENCY: 5,
  WANT_LINK_WITH_NEW_AGENCY: 6,
  UNSATISFIED_COMMISSION_SHARING: 7,
  NO_INTEREST_IN_PROGRAM: 8,
  REASON_CODE_OTHER: 9
};
export var ExtendRelationStatus = {
  EXTEND_RELATION_STATUS_UNSPECIFIED: 0,
  EXTEND_RELATION_STATUS_PENDING_APPROVING: 1,
  EXTEND_RELATION_STATUS_APPROVED: 2,
  EXTEND_RELATION_STATUS_REJECTED: 3,
  EXTEND_RELATION_STATUS_PENDING_UNBINDING: 4,
  EXTEND_RELATION_STATUS_EXPIRED: 5,
  EXTEND_RELATION_STATUS_UNBOUND: 6
};
export var PartnerOrderStatus = {
  UNSPECIFIED: 0,
  ORDERED: 1,
  SETTLED: 2,
  REFUNDED: 3
};
export var CreatorRoleType = {
  DEFAULT: 0,
  OFFICIAL: 1,
  MARKETING: 2
};
export var RelationTag = {
  RELATION_TAG_UNSPECIFIED: 0,
  RELATION_TAG_SELF_INCUBATED: 1,
  HAS_DOMESTIC_ADDRESS: 2
};
export var NoticeCardType = {
  NOTICE_CARD_TYPE_UNSPECIFIED: 0,
  NOTICE_CARD_TYPE_PARTNER_INVITE: 1,
  NOTICE_CARD_TYPE_DATA_REQUEST: 2,
  NOTICE_CARD_TYPE_COMMISSION_REQUEST: 3,
  NOTICE_CARD_TYPE_COMMISSION_RELEASE_REQUEST: 4,
  NOTICE_CARD_TYPE_TALENT_SCOUT_TT_REQUEST: 5,
  NOTICE_CARD_TYPE_TALENT_SCOUT_TT_RELEASE_REQUEST: 6,
  NOTICE_CARD_TYPE_TALENT_SCOUT_COOPERATION_REQUEST: 7,
  NOTICE_CARD_TYPE_PARTNER_RELEASE: 8,
  NOTICE_CARD_TYPE_PARTNER_EXTEND_LINKING_REQUEST: 9,
  NOTICE_CARD_TYPE_SETTLEMENT_REQUEST: 10,
  NOTICE_CARD_TYPE_SETTLEMENT_RELEASE_REQUEST: 11,
  NOTICE_CARD_TYPE_SETTLEMENT_ADJUST_REQUEST: 12,
  NOTICE_CARD_TYPE_PARTNER_UNBIND_REQUEST: 13,
  NOTICE_CARD_TYPE_PARTNER_UNBIND_REJECTED: 14,
  NOTICE_CARD_TYPE_PARTNER_INVITE_COMBINE: 15,
  NOTICE_CARD_TYPE_PARTNER_EXTEND_LINKING_REQUEST_COMBINE: 16,
  NOTICE_CARD_TYPE_PARTNER_EXTEND_PARTIALLY_LINKING_REQUEST: 17,
  NOTICE_CARD_TYPE_PARTNER_UNBIND_REQUEST_COMBINE: 18,
  NOTICE_CARD_TYPE_PARTNER_RELEASE_COMBINE: 19,
  NOTICE_CARD_TYPE_PARTNER_UNBIND_REJECTED_COMBINE: 20,
  NOTICE_CARD_TYPE_SELF_INCUBATED_REQUESTED: 21,
  NOTICE_CARD_TYPE_SELF_INCUBATED_UNTAG: 22,
  NOTICE_CARD_TYPE_PARTNER_INVITE_DATA_SETTLEMENT_COMBINE: 23,
  NOTICE_CARD_TYPE_SETTLEMENT_REQUEST_COMBINE: 24,
  NOTICE_CARD_TYPE_SETTLEMENT_ADJUST_REQUEST_COMBINE: 25,
  NOTICE_CARD_TYPE_EXTEND_LINKING_WITH_SETTLEMENT_REQUEST: 26,
  NOTICE_CARD_TYPE_EXTEND_PARTIALLY_LINKING_WITH_SETTLEMENT_REQUEST: 27,
  NOTICE_CARD_TYPE_EXTEND_LINKING_REQUEST_DATA_SETTLEMENT_COMBINE: 28,
  NOTICE_CARD_TYPE_UNBIND_REJECTED_DATA_SETTLEMENT_COMBINE: 29,
  NOTICE_CARD_TYPE_UNBIND_REJECTED_ONLY_SETTLEMENT_COMBINE: 30,
  NOTICE_CARD_TYPE_SAMPLE_AUTHORIZATION_REQUEST: 31,
  NOTICE_CARD_TYPE_SAMPLE_AUTHORIZATION_END: 32,
  NOTICE_CARD_TYPE_TICKET_AUTHORIZATION_REQUEST: 33
};
export var PromotionPositionType = {
  PROMOTION_POSITION_TYPE_UNSPECIFIED: 0,
  SHOP: 1,
  VIDEO: 2,
  LIVE: 3,
  PRE_LIVE: 4,
  PROMOTION_PAGE: 5
};
export var TaskStatus = {
  TASK_UNFINISHED: 1,
  TASK_FINISHED: 2,
  TASK_FAILED: 3
};
export var PlanType = {
  PLAN_TYPE_UNSPECIFIED: 0,
  PUBLIC: 1,
  TARGET: 2,
  SHOP_PLAN: 3
};
export var BindRelationType = {
  BIND_RELATION_TYPE_UNSPECIFIED: 0,
  BIND_RELATION_TYPE_BIND: 1,
  BIND_RELATION_TYPE_DATA_AUTH: 2,
  BIND_RELATION_TYPE_COMMISSION_AUTH: 3,
  BIND_RELATION_TYPE_TALENT_SCOUT_TT: 4,
  BIND_RELATION_TYPE_EXTEND_BINDING: 5,
  BIND_RELATION_TYPE_SETTLEMENT_AUTH: 6,
  BIND_RELATION_TYPE_SETTLEMENT_ADJUST: 7,
  BIND_RELATION_TYPE_SELF_INCUBATED: 10,
  BIND_RELATION_TYPE_SAMPLE_AUTH: 11,
  BIND_RELATION_TYPE_TICKET_AUTH: 12,
  BIND_RELATION_TYPE_LIVE_COMMISSION: 13
};
export var PartnerTTLoginStatus = {
  PartnerTTLoginStatus_NoConflict: 0,
  PartnerTTLoginStatus_MobileConflict_EmailEmpty: 1,
  PartnerTTLoginStatus_EmailConflict_MobileEmpty: 2,
  PartnerTTLoginStatus_MobileEmailConflictWithSameAccount: 3,
  PartnerTTLoginStatus_MobileConflict_EmailExist: 4,
  PartnerTTLoginStatus_EmailConflict_MobileExist: 5,
  PartnerTTLoginStatus_MobileEmailConflictWithDiffAccount: 6
};
export var PartnerAccountMethodType = {
  PartnerAccountMethod_UNSPECIFIED: 0,
  PartnerAccountMethod_EMAIL: 1,
  PartnerAccountMethod_MOBILE: 2
};
export var PartnerAccountMethodConnectConflictType = {
  PartnerAccountMethodConnectConflict_NoConflict: 0,
  PartnerAccountMethodConnectConflict_TTNotBoundPartner: 1,
  PartnerAccountMethodConnectConflict_TTBoundPartner: 2
};
export var WorkPreference = {
  WORK_PREFERENCE_UNSPECIFIED: 0,
  FULL_TIME: 1,
  PART_TIME: 2,
  BOTH: 3
};
export var Gender = {
  GENDER_UNSPECIFIED: 0,
  MALE: 1,
  FEMALE: 2
};
export var Qualification = {
  QUALIFICATION_ALL_UNSPECIFIED: 0,
  QUALIFICATION_QUALIFIED: 1,
  QUALIFICATION_UNQUALIFIED: 2,
  QUALIFICATION_PENDING: 3
};
export var CooperationStatus = {
  COOPERATION_STATUS_ALL_UNSPECIFIED: 0,
  COOPERATION_STATUS_ACCEPT: 1,
  COOPERATION_STATUS_DECLINED: 2,
  COOPERATION_STATUS_PENDING: 3,
  COOPERATION_STATUS_EXPIRED: 4
};
export var CooperationAction = {
  COOPERATION_ACTION_UNSPECIFIED: 0,
  COOPERATION_ACTION_AGREE: 1,
  COOPERATION_ACTION_DECLINE: 2
};
export var WishListUpdateType = {
  WL_UPDATE_TYPE_UNKNOWN: 0,
  WL_UPDATE_TYPE_ADD: 1,
  WL_UPDATE_TYPE_REMOVE: 2
};
export var CreatorListSortField = {
  SORT_FIELD_DEFAULT: 0,
  SORT_FIELD_FOLLOWERS_CNT: 1,
  SORT_FIELD_VIDEO_AVG_VIEW_CNT: 2,
  SORT_FIELD_LIVE_WATCH_UV: 3
};
export var SortOrder = {
  SORT_ORDER_ASC: 0,
  SORT_ORDER_DESC: 1
};
export var CampaignProductSortField = {
  CampaignProductSortField_DEFAULT: 0,
  CREATE_TIME: 1,
  PRODUCT_SALES: 2,
  TOTAL_COMMISSION_RATE: 3
};
export var MsgCardType = {
  UNKNOWN_CARD_TYPE: 0,
  SUMMARY: 1
};
export var MsgFilterFlag = {
  UNKNOWN_FILTER: 0,
  FILTER_UNREAD: 1
};
export var MsgReadStatus = {
  STATUS_UNREAD: 0,
  STATUS_READ: 1
};
export var MessageTag = {
  NO_TAG: 0,
  IMPORTANT: 1
};
export var PaginationDirection = {
  PREV_PAGE: 1,
  NEXT_PAGE: 2
};
export var FlagType = {
  FLAG_TYPE_UNSPECIFIED: 0,
  FIRST_LOGIN: 1,
  FIRST_LGOIN_AFTER_SETTLE_IN: 2
};
export var PartnerCountry = {
  PartnerCountry_UNSPECIFIED: 0,
  PartnerCountry_CN: 1,
  PartnerCountry_HK: 2,
  PartnerCountry_UK: 3,
  PartnerCountry_ID: 4,
  PartnerCountry_TH: 5,
  PartnerCountry_MY: 6,
  PartnerCountry_VN: 7,
  PartnerCountry_IT: 8,
  PartnerCountry_TR: 9,
  PartnerCountry_PH: 10,
  PartnerCountry_MO: 11,
  PartnerCountry_TW: 12,
  PartnerCountry_SG: 13,
  PartnerCountry_US: 100
};
export var PartnerRegion = {
  PartnerRegion_UNSPECIFIED: 0,
  PartnerRegion_CN: 1,
  PartnerRegion_HK: 2,
  PartnerRegion_GB: 3,
  PartnerRegion_ID: 4,
  PartnerRegion_TH: 5,
  PartnerRegion_MY: 6,
  PartnerRegion_VN: 7,
  PartnerRegion_IT: 8,
  PartnerRegion_TR: 9,
  PartnerRegion_PH: 10,
  PartnerRegion_MO: 11,
  PartnerRegion_TW: 12,
  PartnerRegion_SG: 13,
  PartnerRegion_ES: 14,
  PartnerRegion_IE: 15,
  PartnerRegion_BR: 16,
  PartnerRegion_FR: 17,
  PartnerRegion_DE: 18,
  PartnerRegion_MX: 19,
  PartnerRegion_JP: 20,
  PartnerRegion_US: 100
};
export var PartnerPermission = {
  SETTLEMENT: 2,
  MARKETPLACE: 3,
  SELF_INCUBATED: 5
};
export var ApprovalStatus = {
  APPROVAL_STATUS_UNSPECIFIED: 0,
  APPROVAL_STATUS_APPROVAL: 1,
  APPROVAL_STATUS_FAIL: 2,
  APPROVAL_STATUS_PENDING: 3
};
export var SettleInType = {
  SETTLEINTYPE_UNSPECIFIED: 0,
  FIRST_TIME_SETTLEIN: 1,
  ADD_ROLE: 2
};
export var EntityCertificateType = {
  CERTIFICATE_TYPE_UNSPECIFIED: 0,
  BUSINESS_LICENSE: 1,
  CERTIFICATE_OF_INCORPORATION: 2,
  BUSINESS_REGISTRATION_CERTIFICATE: 3,
  NOMOR_INDUK_BERUSAHA: 4,
  ACRA_BIZFILE: 5
};
export var BizOwnerIDType = {
  BIZ_OWNER_ID_TYPE_UNSPECIFIED: 0,
  IDENTITY_CARD: 1,
  PASSPORT: 2,
  DRIVING_LICENSE: 3,
  HK_IDENTITY_CARD: 4,
  SOCIAL_SECURITY: 5,
  US_PASSPORT: 6,
  DOCUMENTO_NACIONAL_DE_IDENTIDAD: 7
};
export var MultiLanguageType = {
  MULTI_LANGUAGE_TYPE_UNSPECIFIED: 0,
  CN: 1,
  EN: 2,
  ID: 3,
  MY: 4,
  VN: 5,
  TH: 6,
  IT: 7,
  TR: 8,
  PH: 9,
  ES: 10,
  IE: 11,
  BR: 12,
  FR: 13,
  DE: 14,
  JP: 15
};
export var PartnerRegionType = {
  PARTNER_REGION_UNSPECIFIED: 0,
  PARTNER_REGION_LOCAL: 1,
  PARTNER_REGION_CROSS_BORDER: 2
};
export var CompanyInfoField = {
  COMPANY_INFO_FIELD_UNSPECIFIED: 0,
  COMPANY_LOGO: 100,
  COMPANY_NAME: 101,
  COMPANY_BACKGROUND: 102,
  MAIN_SERVICE_INDUSTRY: 103,
  MAIN_SERVICE_SCOPE: 104,
  COMPANY_INTRODUCTION: 105,
  BUSINESS_ADDRESS: 106,
  PERSONAL_IDENTIFICATION: 107,
  REGISTERED_BUSINESS_ADDRESS: 108,
  CONTACT_PERSON: 200,
  CONTACT_EMAIL: 201,
  CONTACT_PHONE_NUMBER: 202,
  CERTIFICATE_OF_SALES: 300,
  COOPERATIVE_MERCHANT_ACCOUNT: 301,
  MERCHANT_COOPERATION_AGREEMENT: 302,
  COOPERATIVE_CREATOR_ACCOUNT: 303,
  CREATOR_COOPERATION_AGREEMENT: 304,
  EXPERIENCE_IN_CONTENT: 305,
  WORK_ENVIRONMENT: 306,
  NEED_REFERRAL_BONUS: 307,
  REFERRAL_BONUS_TYPE: 308,
  AFFILIATE_PARTNER_OPERATIONS: 309,
  CORPORATE_ENTITY_NAME: 400,
  ENTITY_CERTIFICATE_TYPES: 401,
  REGISTERED_DATE: 402,
  ENTITY_CERTIFICATE_IMAGE: 403,
  CERTIFICATE_NUMBER: 404,
  BIZ_OWNER_ID_TYPES: 405,
  BIZ_OWNER_ID_IMAGE: 406
};
export var PenaltyStatus = {
  PenaltyStatus_Processing: 1,
  PenaltyStatus_Success: 2,
  PenaltyStatus_Failed: 3
};
export var SettlementFileStatus = {
  EXPORTING: 1,
  EXPORTED: 2,
  VIEWED: 3
};
export var PayAccountStatus = {
  ACCOUNT_STATUS_UNSPECIFIED: 0,
  VERIFIED: 1,
  UNVERIFIED: 2,
  VERIFYING: 3,
  VERIFY_FAILED: 4
};
export var MCNListEffectiveScene = {
  MCN_LIST_EFFECTIVE_SCENE_UNSPECIFIED: 0,
  MCN_LIST_EFFECTIVE_SCENE_CREATOR: 1,
  MCN_LIST_EFFECTIVE_SCENE_SELLER: 2,
  MCN_LIST_EFFECTIVE_SCENE_EXTERNAL: 3,
  MCN_PROFILE_PAGE: 4
};
export var MCNListTab = {
  MCN_LIST_TAB_UNSPECIFIED: 0,
  MCN_LIST_TAB_LOCAL: 1,
  MCN_LIST_TAB_CROSS_BORDER: 2,
  MCN_LIST_TAB_MIX_LOCAL_CB: 3
};
export var ListType = {
  LIST_TYPE_UNSPECIFIED: 0,
  LIST_TYPE_TAP_LIST: 1
};
export var CampaignViewStatus = {
  CAMPAIGN_DRAFT: 1,
  CAMPAIGN_SUBMITTED: 2,
  CAMPAIGN_ONLINE: 3,
  CAMPAIGN_ENDED: 4,
  CAMPAIGN_DELETED: 99
};
export var CampaignProductStatus = {
  PRODUCT_UNSPECIFIED: 0,
  PRODUCT_PENDING: 1,
  PRODUCT_APPROVED: 2,
  PRODUCT_REJECTED: 3,
  PRODUCT_PENDING_CLOSED: 4,
  PRODUCT_CLOSED: 5
};
export var CampaignProductSubStatus = {
  PRODUCT_SUB_STATUS_UNSPECIFIED: 0,
  PRODUCT_SUB_STATUS_ONGOING_PENDING: 1,
  PRODUCT_SUB_STATUS_ONGOING_EFFECT: 2,
  PRODUCT_SUB_STATUS_ONGOING_EDIT: 3,
  PRODUCT_SUB_STATUS_REJECT_ONCE: 4,
  PRODUCT_SUB_STATUS_REJECT_FOREVER: 5,
  PRODUCT_SUB_STATUS_CLOSED: 6
};
export var CampaignOperateType = {
  PUBLISH: 1,
  OFFLINE: 2,
  DELETE: 3
};
export var CampaignType = {
  ALL_CAMPAIGN: 1,
  TARGET_CAMPAIGN: 2
};
export var CrsCampaignType = {
  PARTNER_DISTRIBUTION: 1,
  GS_DISTRIBUTION: 2,
  GS_SUB_DISTRIBUTION: 3,
  SELLER_REQUESTED_DISTRIBUTION: 4,
  SELLER_REQUESTED_SUB_DISTRIBUTION: 5,
  OPS_REQUESTED_DISTRIBUTION: 6,
  OPS_REQUESTED_SUB_DISTRIBUTION: 7
};
export var SellerType = {
  SELLER_ALL: 1,
  SELLER_L2L: 2,
  SELLER_CB: 3
};
export var CampaignSortField = {
  CampaignSortField_DEFAULT: 0,
  PENDING_APPROVAL: 1,
  CAMPAIGN_PERIOD: 2,
  CAMPAIGN_REGISTRATION: 3,
  CAMPAIGN_COMMISSION_RATE: 4,
  APPLIED_PRODUCT_NUM: 5,
  SAMPLE_QUANTITY: 6,
  SELLER_CAMPAIGN_TYPE: 7
};
export var CampaignSortDirection = {
  ASC: 1,
  DESC: 2
};
export var ShopFailType = {
  CODE_INVALID: 1,
  MARKET_DIFFERENT: 2
};
export var ExportDataType = {
  CAMPAIGN_PRODUCT: 1
};
export var ExportStatus = {
  EXPORT_INIT: 1,
  EXPORT_PROCESSING: 2,
  EXPORT_SUCCESS: 3,
  EXPORT_FAIL: 4
};
export var CampaignContactType = {
  WHATSAPP: 1,
  EMAIL: 2,
  PHONE: 3,
  ZALO: 4,
  VIBER: 5,
  LINE: 6
};
export var CampaignProductUnavailableType = {
  CAMPAIGN_PRODUCT_DEACTIVATED: 1,
  CAMPAIGN_SHOP_WITHDRAW: 2,
  CAMPAIGN_SHOP_CLOSING: 3,
  CAMPAIGN_PRODUCT_RISKED: 4,
  CAMPAIGN_SHOP_RISKED: 5,
  CAMPAIGN_PRODUCT_DEACTIVATED_BY_SELLER: 6,
  CAMPAIGN_PRODUCT_DEACTIVATED_BY_SYSTEM: 7
};
export var CampaignVersion = {
  MVP: 0,
  MULTI_CREATOR_COMMISSION: 1
};
export var SellerRequestedCampaignType = {
  SELLER_CAMPAIGN_UNSPECIFIED: 0,
  SELLER_CAMPAIGN_ALL_PARTNER: 1,
  SELLER_CAMPAIGN_INVITED_PARTNER: 2
};
export var CampaignListScene = {
  PARTNER_CAMPAIGN_UNSPECIFIED: 0,
  PARTNER_MY_CAMPAIGNS: 1,
  PARTNER_CAMPAIGN_MARKETPLACE: 2,
  PARTNER_GS_CAMPAIGNS: 3
};
export var PartnerJoinStatus = {
  PARTNER_NO_ACTION: 0,
  PARTNER_JOINED: 1,
  PARTNER_DECLINED: 2
};
export var DeboostedCode = {
  DEBOOSTE_UNSPECIFIED: 0,
  NEGATIVE_REVIEW: 1,
  HIGH_RETURN_RATE: 2,
  LOW_SES: 3,
  HIGHER_PRICE: 4
};
export var FreeSampleStatus = {
  NotRequested: 0,
  Pending: 10,
  AwaitingShipment: 20,
  AwaitingCollection: 21,
  Shipped: 30,
  ContentPending: 40,
  RejectCancelled: 51,
  OverdueCancelled: 52,
  UnFulfilCancelled: 53,
  DelPlanCancelled: 54,
  SellerNotShipCancelled: 55,
  WithdrawCancelled: 56,
  UnfulfillableCancelled: 57,
  OperatorManualCancelled: 61,
  OperatorManualFailed: 62,
  OperatorManualCompleted: 63,
  Completed: 100
};
export var PromotionCreatorContentType = {
  PromotionCreatorContentType_VIDEO: 1,
  PromotionCreatorContentType_ROOM: 2
};
export var DeliveryOption = {
  DeliveryOption_STANDARD: 1,
  DeliveryOption_EXPRESS: 2,
  DeliveryOption_ECONOMY: 3,
  DeliveryOption_SEND_BY_SELLER: 4
};
export var MigrationStatus = {
  MIGRATION_UNSPECIFIED: 1,
  MIGRATION_STOP_SETTLE: 2,
  MIGRATION_PROCESSING: 3,
  MIGRATION_FINISHED: 4
};
export var ProductRankingThemeType = {
  RANKING_THEME_TOP_SALE: 0,
  RANKING_THEME_TOP_RATED: 1,
  RANKING_THEME_TRENDING: 2
};
export var ProductStockStatus = {
  PRODUCT_STOCK_STATUS_IN_STOCK: 1,
  PRODUCT_STOCK_STATUS_SOLD_OUT: 2
};
export var ProductStatus = {
  PRODUCT_STATUS_ON_SALES: 90,
  PRODUCT_STATUS_OUT_OF_STOCK: 80,
  PRODUCT_STATUS_DOWN: 70,
  PRODUCT_STATUS_REVIEW_FAILED: 40,
  PRODUCT_STATUS_UNDER_REVIEW: 30,
  PRODUCT_STATUS_RE_UNDER_REVIEW: 75
};
export var LabelType = {
  LABEL_TYPE_FREE_SAMPLE: 1,
  LABEL_TYPE_OFFICIAL_PRODUCT: 2
};
export var PartnerProductLabelType = {
  PARTNER_PRODUCT_LABEL_UNSPECIFIED: 0,
  PARTNER_PRODUCT_LABEL_DEBOOST: 1,
  PARTNER_PRODUCT_LABEL_BLACK_FRIDAY: 2,
  PARTNER_PRODUCT_LABEL_SPRING_FESTIVAL_NO_CLOSING_FS: 100,
  PARTNER_PRODUCT_LABEL_SPRING_FESTIVAL_NO_CLOSING_POP: 101
};
export var SingleSelectionFilterType = {
  FILTER_FREE_SAMPLE: 1,
  FILTER_LIVE_ELIGIBLE_PRODUCTS: 2
};
export var DoubleSelectionFilterType = {
  FILTER_DEFAULT: 0,
  FILTER_COMMISSION_RATE: 1,
  FILTER_PRICE: 2,
  FILTER_SALE: 3,
  FILTER_STORE_RATING: 4
};
export var SelectionProductSorterType = {
  SORTER_RECOMMENDED: 0,
  SORTER_SALE_HIGH_TO_LOW: 1,
  SORTER_PRICE_LOW_TO_HIGH: 2,
  SORTER_PRICE_HIGH_TO_LOW: 3,
  SORTER_NEWEST_ARRIVALS: 4
};
export var InfoLevel = {
  INFO_LEVEL_LITE: 1,
  INFO_LEVEL_FULL: 2
};
export var FailReason = {
  FAIL_REASON_DEFAULT: 0,
  FAIL_REASON_UNKNOWN: 1,
  FAIL_REASON_URL_UNIDENTIFIABLE: 2,
  FAIL_REASON_PRODUCT_DOWN: 3,
  FAIL_REASON_PRODUCT_REGION_UNAVAILABLE: 4,
  FAIL_REASON_PRODUCT_UNDER_REVIEW: 5,
  FAIL_REASON_PRODUCT_PLAN_FAIL: 6,
  FAIL_REASON_PRODUCT_NOT_IN_AFFILIATE: 7,
  FAIL_REASON_CAMPAIGN_URL: 8
};
export var ProductSetGuideType = {
  GUIDE_TYPE_SHARE_GUIDE: 1,
  GUIDE_TYPE_UNSHARED_TIP: 2
};
export var CommissionRewardStatus = {
  COMMISSION_REWARD_STATUS_UNSPECIFIED: 0,
  COMMISSION_REWARD_STATUS_UPCOMING: 1,
  COMMISSION_REWARD_STATUS_ONGOING: 2,
  COMMISSION_REWARD_STATUS_ENDED: 3
};
export var CommissionRewardOrderType = {
  COMMISSION_REWARD_ORDER_TYPE_UNSPECIFIED: 0,
  COMMISSION_REWARD_ORDER_TYPE_ALL: 1,
  COMMISSION_REWARD_ORDER_TYPE_LIVE: 2,
  COMMISSION_REWARD_ORDER_TYPE_NEW_CONTENT: 3
};
export var LiveHubLeadStatus = {
  LEAD_STATUS_NEW: 0,
  LEAD_STATUS_REACHING: 1,
  LEAD_STATUS_REACHED: 2,
  LEAD_STATUS_INVALID: 3
};
export var ProductAffiliateInfo = {
  AddStatus: {
    CAN_BE_ADD: 1,
    ADDED: 2
  },
  PlanType: {
    PLAN_TYPE_UNSPECIFIED: 0,
    PLAN_TYPE_PUBLIC: 1,
    PLAN_TYPE_TARGET: 2,
    PLAN_TYPE_SHOP: 3,
    PLAN_TYPE_PLATFORM: 4,
    PLAN_TYPE_PARTNER: 5
  },
  PlanBindStatus: {
    PLAN_BIND_STATUS_UNSPECIFIED: 0,
    PLAN_BIND_STATUS_BINDED: 1,
    PLAN_BIND_STATUS_UNDER_REVIEW: 2,
    PLAN_BIND_STATUS_REJECTED: 3
  }
};
export var IMProductInfo = {
  ProductStatus: {
    PRODUCT_STATUS_AVAILABLE: 0,
    PRODUCT_STATUS_UNAVAILABLE: 1
  }
};
export var IMCampaignProductInfo = {
  ProductSubStatus: {
    PRODUCT_SubStatus_Enable: 0,
    PRODUCT_SubStatus_Disable: 1
  }
};